import { useNavigate } from 'react-router-dom';

export default function CtaBanner() {
  const navigate = useNavigate();
  return (
    <section className="py-20 bg-gradient-to-r from-emerald-600 to-teal-600">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-white/20 mx-auto mb-6">
          <i className="ri-rocket-line text-white text-3xl"></i>
        </div>
        <h2 className="text-4xl font-extrabold text-white mb-4">
          Your Success Story Starts Today
        </h2>
        <p className="text-white/85 text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Join 2,400+ students who transformed their math grades with a proven, step-by-step system built by a 30-year NYC educator.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate('/#membership-tiers')}
            className="px-8 py-4 bg-white text-emerald-700 font-bold rounded-xl hover:bg-emerald-50 transition-all duration-300 whitespace-nowrap cursor-pointer text-base shadow-lg"
          >
            View Membership Plans
          </button>
          <button
            onClick={() => navigate('/free-lessons')}
            className="px-8 py-4 bg-white/15 border border-white/40 text-white font-bold rounded-xl hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer text-base"
          >
            Try Free Lessons First
          </button>
        </div>
      </div>
    </section>
  );
}
